import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404 error</h1>
            <p>Page Not Found</p>
        </div>
    );
};

export default NotFound;